import { useQuery } from '@tanstack/react-query';
import { useTypedOpenApi } from '../../providers';
import { featuredPublicChecklistsQueryOptions } from './publicChecklistQueries';
import type { PublicChecklistsQueryParams } from './types';

/**
 * The curated shelf — `GET /checklists/featured`.
 *
 * New capability that came with the REST endpoints; nothing surfaces it yet, and it is here so the
 * screen that eventually does has the same cache policy as the rest of the library.
 */
export const useFeaturedPublicChecklistsQuery = (params: PublicChecklistsQueryParams, enabled = true) => {
  const { apiClient } = useTypedOpenApi();

  return useQuery({ ...featuredPublicChecklistsQueryOptions(apiClient, params), enabled });
};
